<template>
  <div class="scriptLibrary-container">
    <div class="operat_row">
      <div class="operat_left">
        <el-input
          size="mini"
          placeholder="请输入搜索内容"
          v-model="paramsObj.keyword"
          clearable
          @keyup.enter.native="handleSearch()"
        >
        </el-input>
        <el-button-group>
          <el-button size="mini">一级分类</el-button>
          <el-select
            size="mini"
            v-model="paramsObj.oneClassId"
            placeholder="请选择"
            clearable
            v-loading="loading1"
          >
            <el-option
              v-for="item in oneOptions"
              :key="item.classId"
              :label="item.className"
              :value="item.classId"
            >
            </el-option>
          </el-select>
        </el-button-group>
        <el-button-group>
          <el-button size="mini">二级分类</el-button>
          <el-select
            size="mini"
            v-model="paramsObj.twoClassId"
            placeholder="请选择"
            clearable
            v-loading="loading2"
            :disabled="!paramsObj.oneClassId"
          >
            <el-option
              v-for="item in twoOptions"
              :key="item.classId"
              :label="item.className"
              :value="item.classId"
            >
            </el-option>
          </el-select>
        </el-button-group>
        <el-button-group>
          <el-button size="mini">三级分类</el-button>
          <el-select
            size="mini"
            v-model="paramsObj.threeClassId"
            placeholder="请选择"
            clearable
            v-loading="loading3"
            :disabled="!paramsObj.twoClassId"
          >
            <el-option
              v-for="item in threeOptions"
              :key="item.classId"
              :label="item.className"
              :value="item.classId"
            >
            </el-option>
          </el-select>
        </el-button-group>
        <el-button size="mini" @click="clearParams">清空</el-button>
        <el-button size="mini" type="primary" @click="handleSearch()"
          >查询</el-button
        >
      </div>
      <div class="operat_right">
        <el-button
          type="primary"
          size="mini"
          @click="handleEditAdd('', 'add')"
          v-if="hasAuth('cjhs')"
          >创建话术</el-button
        >
        <el-button
          type="primary"
          size="mini"
          @click="dialogVisiClass = true"
          v-if="hasAuth('glfl')"
          >管理分类</el-button
        >
        <el-button
          type="primary"
          size="mini"
          @click="dialogVisiImport = true"
          v-if="hasAuth('daoru')"
          >导入</el-button
        >
      </div>
    </div>

    <el-table
      size="small"
      :data="tableData"
      highlight-current-row
      align="center"
      height="calc(100vh - 250px)"
      :header-cell-style="{ background: '#F9F9F9' }"
      ref="cusChatTable"
      style="font-size: 13px"
      v-loading="loading"
    >
      <el-table-column type="index" width="50px" />
      <el-table-column
        prop="title"
        label="话术标题"
        min-width="250px"
        show-overflow-tooltip
      />
      <el-table-column prop="oneClassName" label="一级分类" width="150px" />
      <el-table-column prop="twoClassName" label="二级分类" width="150px" />
      <el-table-column prop="threeClassName" label="三级分类" width="150px" />
      <el-table-column prop="content" label="话术内容" width="300px">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title=""
            width="800"
            trigger="hover"
            popper-class="workorder-problem-desc"
          >
            <div>{{ scope.row.content }}</div>
            <span slot="reference" class="span_hidden">
              {{ scope.row.content }}
            </span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="useNum" label="引用次数" width="150px" />
      <el-table-column prop="orderNo" label="排序" width="150px" />
      <el-table-column prop="createTime" label="创建时间" width="200px" />
      <el-table-column prop="userName" label="创建人" width="150px" />
      <el-table-column label="操作" fixed="right" width="120px">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="handleEditAdd(scope.row, 'edit')"
            >编辑</el-button
          >
          <el-button @click="handleDelete(scope.row)" type="text" size="small"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-bind:childMsg="paramsObj"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination>
    <!-- <el-pagination
      @size-change="getData()"
      @current-change="getData()"
      :current-page.sync="paramsObj.pageNum"
      :page-sizes="[20, 50, 100, 200]"
      :page-size.sync="paramsObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count"
    >
    </el-pagination> -->

    <addEditPopup
      v-if="dialogVisible"
      :dialogVisible.sync="dialogVisible"
      :popupConfig="popupConfig"
      @getData="getData()"
    ></addEditPopup>
    <manageClassPopup
      v-if="dialogVisiClass"
      :dialogVisiClass.sync="dialogVisiClass"
      @getData="getData()"
    ></manageClassPopup>
    <importPopup
      v-if="dialogVisiImport"
      :dialogVisiImport.sync="dialogVisiImport"
      @getData="getData()"
    ></importPopup>
  </div>
</template>
<script>
import { getClassApi, getList, deleteScript } from "@/api/sciptLibrary/index";
import addEditPopup from "./addEditPopup.vue";
import manageClassPopup from "./manageClassPopup.vue";
import importPopup from "./importPopup.vue";
export default {
  name: "scriptLibrary",
  components: {
    addEditPopup,
    manageClassPopup,
    importPopup,
  },
  data() {
    return {
      dialogVisible: false,

      dialogVisiClass: false,
      dialogVisiImport: false,
      loading: false,
      loading1: false,
      loading2: false,
      loading3: false,
      oneOptions: [],
      twoOptions: [{ classId: "", className: "全部" }],
      threeOptions: [{ classId: "", className: "全部" }],
      paramsObj: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
        keyword: "",
        oneClassId: "",
        twoClassId: "",
        threeClassId: "",
      },
      formInline: {
        pageNum: 1,
        pageSize: 20,
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      // count: 0,
      tableData: [],
      // tableHeight: 200,
      popupConfig: {
        title: "",
        scriptId: "",
      },
      cfunBu: [],
    };
  },
  mounted() {
    this.getOneClassData();
    // this.$nextTick(function () {
    //   this.tableHeight = window.innerHeight - this.$refs.cusChatTable.$el.offsetTop - 150
    //   // 监听窗口大小变化
    //   let self = this;
    //   window.onresize = function () {
    //     self.tableHeight = window.innerHeight - self.$refs.cusChatTable.$el.offsetTop - 32
    //   }
    // })
  },
  methods: {
    // 权限
    hasAuth(val) {
      if (this.cfunBu.length < 1) {
        return false;
      }

      return this.cfunBu.some((e) => {
        return e == val;
      });
    },
    // 获取分类选项(level:1/2/3, parentId:上级分类id, 一级传-1) 统一加"全部" 并把接口的id映射为classId
    async fetchClassOptions(level, parentId) {
      const fallback = [{ classId: "", className: "全部" }];
      try {
        const res = await getClassApi({ level, parentId }, true);
        let data = [];
        if (
          res &&
          res.error &&
          res.error.code == 200 &&
          Array.isArray(res.data)
        ) {
          data = res.data;
        } else if (res && res.code == 200 && Array.isArray(res.data)) {
          data = res.data;
        } else if (Array.isArray(res)) {
          data = res;
        }
        return [
          ...fallback,
          ...data.map((item) => ({ ...item, classId: item.id })),
        ];
      } catch (e) {
        return fallback;
      }
    },
    async getOneClassData() {
      this.loading1 = true;
      this.oneOptions = await this.fetchClassOptions(1, -1);
      this.loading1 = false;
      this.getData();
    },

    // 点击查询/回车：回到第一页后再请求（分页组件显示用的是 paramsObj.currentPage，需同步重置）
    handleSearch() {
      this.formInline.pageNum = 1;
      this.paramsObj.currentPage = 1;
      this.getData();
    },
    clearParams() {
      this.paramsObj.keyword = "";
      this.paramsObj.oneClassId = "";
      this.paramsObj.twoClassId = "";
      this.paramsObj.threeClassId = "";
      this.formInline.pageNum = 1;
      this.paramsObj.currentPage = 1;
      this.getData();
    },
    // 获取数据
    async getData() {
      this.loading = true;
      try {
        const requestParams = {
          ...this.paramsObj,
          ...this.formInline,
        };
        let res = await getList(requestParams, true);
        if (res && res.error && res.error.code == 200 && res.data) {
          this.tableData = res.data.data || [];
          this.paramsObj.total = res.data.count || 0;
        } else {
          this.tableData = [];
          this.paramsObj.total = 0;
        }
      } catch (e) {
        this.tableData = [];
        this.paramsObj.total = 0;
      } finally {
        this.loading = false;
      }
    },

    handleEditAdd(row, type) {
      if (type == "add") {
        this.popupConfig.title = "创建话术库";
        this.popupConfig.scriptId = "";
      } else {
        this.popupConfig.title = "编辑话术库";
        this.popupConfig.scriptId = row.scriptId;
      }
      this.dialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除该话术, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api();
        })
        .catch(() => {});

      const api = async () => {
        this.loading = true;
        let res = await deleteScript(row.scriptId, true);
        if (res.error.code == 200) {
          this.getData();
          this.$message({
            type: "success",
            message: "删除成功",
          });
        } else {
          this.$message({
            type: "error",
            message: res.error.message,
          });
        }
        this.loading = false;
      };
    },
    //分页回调
    callBack(parm) {
      this.formInline.pageNum = parm.currentPage || parm.pageNum;
      this.formInline.pageSize = parm.pageSize;
      console.log("this.paramsObj.pageSize ++++", this.paramsObj);
      this.getData();
    },
    manageClass() {},
    importData() {},
  },
  watch: {
    // 仅做级联加载选项和重置下级选中值，不触发查询（点"查询"才请求）
    "paramsObj.oneClassId": {
      async handler(newVal) {
        if (newVal) {
          this.loading2 = true;
          const options = await this.fetchClassOptions(2, newVal);
          this.loading2 = false;
          // 请求期间选中值又变了，丢弃过期结果，由新的watcher回调负责重置
          if (this.paramsObj.oneClassId !== newVal) return;
          this.twoOptions = options;
        } else {
          this.twoOptions = [{ classId: "", className: "全部" }];
        }
        this.threeOptions = [{ classId: "", className: "全部" }];
        this.paramsObj.twoClassId = "";
        this.paramsObj.threeClassId = "";
      },
    },
    "paramsObj.twoClassId": {
      async handler(newVal) {
        if (newVal) {
          this.loading3 = true;
          const options = await this.fetchClassOptions(3, newVal);
          this.loading3 = false;
          // 请求期间选中值又变了，丢弃过期结果
          if (this.paramsObj.twoClassId !== newVal) return;
          this.threeOptions = options;
        } else {
          this.threeOptions = [{ classId: "", className: "全部" }];
        }
        this.paramsObj.threeClassId = "";
      },
    },
    btnAuthority: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "话术库") {
              console.log(885, item);
              setTimeout(() => {
                this.cfunBu = item.cfunBu;
              }, 300);
              // let senBtnAuthority = item.cfunBu
              // let arr = ['kxjbjsc', 'kxz', 'hmbqgl', 'hmhyygl']
              // this.authorityContainer = []
              // arr.forEach(item => {
              //   if (senBtnAuthority.indexOf(item) != -1) {
              //     // 有权限
              //     this.authorityContainer.push(true)
              //   } else {
              //     // 没有权限
              //     this.authorityContainer.push(false)
              //   }
              // })
            }
          });
          console.log("this.authorityContainer", this.authorityContainer);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    btnAuthority() {
      console.log(9999, this.$store.state.tagsView.roleAuthrority);
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
};
</script>
<style lang="scss" scoped>
.scriptLibrary-container {
  height: 100%;
  .operat_row {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .operat_left {
      /deep/ .el-button-group {
        margin-right: 15px;
      }
      .el-input {
        width: 200px;
        margin-right: 15px;
      }
    }

    .operat_right {
    }
  }

  .span_hidden {
    display: -webkit-box;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
</style>
